import React from 'react';
import ReactDOM from 'react-dom/client';
import LandingPage from './LandingPage.jsx';
import LandingPageLegacy from './LandingPageLegacy.jsx';
import { getLandingThemeVersion } from '../utils/landingThemeVersion';
// Real compiled Tailwind (tailwind.config.js/postcss.config.js) rather than
// the CDN script index.html uses — the CDN approach is fine for the app
// shell (already logged-in usage), but a public marketing page benefits
// directly from not fetching an extra external script before first paint.
import '../index.css';

// See src/utils/landingThemeVersion.js — a system admin can flip this back to
// the pre-redesign page from Dev Tools, on their own browser only.
const ActiveLandingPage = getLandingThemeVersion() === 'legacy' ? LandingPageLegacy : LandingPage;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ActiveLandingPage />
  </React.StrictMode>
);
